import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useQueryClient } from 'react-query';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { usePlaidLink } from '../../../../../../_hooks/plaid/usePlaidLink';
import { ACCOUNTS_QUERY_KEY } from '../../../../AccountsConstants';
import { MANAGE_LINKS_QUERY_KEY } from '../../../../api/useLinksQuery';
import { ACCOUNT_PREFERENCES_QUERY_KEY } from '../../../../api/useAccountsQuery';
import { setIsPlaidInfoMessageVisibility } from '../../../../../../Plaid/state/actions';
import { AddAccountButtonsGroup } from '../../../../components/AddAccountPreSelection/components/AddAccountButtonsGroup';
import {
  hasPlaidSelector as selectHasPlaid,
  selectCurrentClient,
} from '../../../../../../CommonSelectors/CommonAreaSelector';

interface Props {
  onClose(): void;
  onManualClick(): void;
  showQuovoMessage(): void;
  onOpenAkoyaLinkManagementModal(): void;
  showExternalProviders: boolean;
}

export const AddAccountPreSelectionModal = ({
  onClose,
  onManualClick,
  showQuovoMessage,
  onOpenAkoyaLinkManagementModal,
  showExternalProviders = true,
}: Props) => {
  const dispatch = useDispatch();

  const queryClient = useQueryClient();

  const { Id: clientId } = useSelector(selectCurrentClient);

  const hasPlaidSelector = useSelector(selectHasPlaid);

  const { open: openPlaid, isLoading } = usePlaidLink({
    clientId,
    onStart: () => {
      onClose();
    },
    onSuccess: () => {
      dispatch(setIsPlaidInfoMessageVisibility(true));
      queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY, MANAGE_LINKS_QUERY_KEY]);
      queryClient.invalidateQueries([ACCOUNTS_QUERY_KEY, ACCOUNT_PREFERENCES_QUERY_KEY]);
    },
  });

  return (
    <>
      <Modal
        isOpen
        onRequestClose={onClose}
        aria={{ labelledby: 'add-account-pre-selection-modal' }}
      >
        <ModalHeader id="add-account-pre-selection-modal">Add an Account</ModalHeader>

        <ModalCloseButton onClick={onClose} />

        <ModalBody>
          <AddAccountButtonsGroup
            isLoading={isLoading}
            plaidOnClick={() => {
              if (hasPlaidSelector) {
                openPlaid();
              } else {
                onClose();
                showQuovoMessage();
              }
            }}
            showExternalAccountProviders={showExternalProviders}
            manualOnClick={onManualClick}
            onOpenAkoyaLinkManagementModal={onOpenAkoyaLinkManagementModal}
          />
        </ModalBody>
      </Modal>
    </>
  );
};
